import { toast } from '../ui/toast.js';

/* ══════════ PWA: Service Worker registrieren + Install-Angebot ══════════ */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('sw.js').catch(() => { /* offline nicht kritisch */ });
  });
}
let deferredInstall = null;
/* Nur lesend nach außen – gesetzt wird der Wert ausschließlich hier. */
export { deferredInstall };
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredInstall = e;
  const btn = document.getElementById('btn-install');
  if (btn) btn.classList.remove('hidden');
});
window.addEventListener('appinstalled', () => {
  deferredInstall = null;
  const btn = document.getElementById('btn-install');
  if (btn) btn.classList.add('hidden');
});
export async function promptInstall() {
  if (!deferredInstall) { if (typeof toast === 'function') toast('Über das Browser-Menü „Zum Startbildschirm hinzufügen".'); return; }
  deferredInstall.prompt();
  try { await deferredInstall.userChoice; } catch (e) { /* egal */ }
  deferredInstall = null;
  const btn = document.getElementById('btn-install');
  if (btn) btn.classList.add('hidden');
}
